import React from 'react';
import { usePopper, CustomPopperProps } from '../usePopper/usePopper';

export const PORTAL_POPPERS_WRAPPER_TEST_ID = 'portal-poppers-test-id';
export const PORTAL_POPPERS_WRAPPER_ID = 'portal-poppers-id';

export function usePortalPopper<
  RefElementType extends HTMLElement = HTMLElement,
  PopperElementType extends HTMLElement = HTMLElement,
>(popperOptions?: CustomPopperProps) {
  const [poppersWrapper, setPoppersWrapper] =
    React.useState<HTMLElement | null>();

  React.useEffect(() => {
    initPoppersWrapper(setPoppersWrapper);

    return () => {
      const poppersWrapperElement = document.getElementById(
        PORTAL_POPPERS_WRAPPER_ID,
      );

      if (
        poppersWrapperElement &&
        poppersWrapperElement.childNodes.length <= 1
      ) {
        removeFromDOM(poppersWrapperElement);
      }
    };
  }, []);

  const popperReturnVal = usePopper<RefElementType, PopperElementType>(
    popperOptions,
  );

  return {
    ...popperReturnVal,
    poppersWrapper,
  };
}

const createPoppersWrapper = () => {
  const el = document.createElement('div');

  el.setAttribute('data-testid', PORTAL_POPPERS_WRAPPER_TEST_ID);
  el.setAttribute('id', PORTAL_POPPERS_WRAPPER_ID);

  return el;
};

const initPoppersWrapper = (
  setPoppersWrapper: React.Dispatch<
    React.SetStateAction<HTMLElement | null | undefined>
  >,
) => {
  let poppersWrapperElement = document.getElementById(
    PORTAL_POPPERS_WRAPPER_ID,
  );

  if (!poppersWrapperElement) {
    poppersWrapperElement = createPoppersWrapper();
    document.body.appendChild(poppersWrapperElement);
  }

  setPoppersWrapper(poppersWrapperElement);
};

const removeFromDOM = (el: HTMLElement) => el?.remove();
